import {
  QuantityCaptureMethod,
  InventoryTagStatus,
  TagType,
} from '@rematter/frontend-lib-api-client/grpc/inventory/v1/inventory_tag_pb';

export const inventoryTagStatusLabels: Record<InventoryTagStatus, string> = {
  [InventoryTagStatus.UNSPECIFIED]: 'Unspecified',
  [InventoryTagStatus.ACTIVE]: 'Active',
  [InventoryTagStatus.REVISED]: 'Revised',
  [InventoryTagStatus.CANCELLED]: 'Cancelled',
  [InventoryTagStatus.CONFIRMED]: 'Confirmed',
  [InventoryTagStatus.DRAFT]: 'Draft',
  [InventoryTagStatus.IN_INVENTORY]: 'In Inventory',
  [InventoryTagStatus.IN_TRANSFER]: 'In Transfer',
  [InventoryTagStatus.LOADED]: 'Loaded',
  [InventoryTagStatus.PENDING_PURCHASE]: 'Pending Purchase',
  [InventoryTagStatus.RESERVED]: 'Reserved',
  [InventoryTagStatus.SHIPPED]: 'Shipped',
  [InventoryTagStatus.SOLD]: 'Sold',
  [InventoryTagStatus.TRANSFERRED]: 'Transferred',
  [InventoryTagStatus.VOIDED]: 'Voided',
};

export const tagTypeLabels: Record<TagType, string> = {
  [TagType.UNSPECIFIED]: 'Unspecified',
  [TagType.WORK_IN_PROGRESS]: 'Work in Progress',
  [TagType.FINISHED_GOOD]: 'Finished Good',
};

export const quantityCaptureMethodLabels: Record<
  QuantityCaptureMethod,
  string
> = {
  [QuantityCaptureMethod.UNSPECIFIED]: 'Unspecified',
  [QuantityCaptureMethod.AUTOMATIC]: 'Automatic',
  [QuantityCaptureMethod.MANUAL]: 'Manual',
};
